export default "__VITE_ASSET__ZUZOAL99__"